import { ToastHub } from './lib/ToastHub';
import { useToast } from './lib/useToast';
export { toastClasses } from './lib/style';
export { ToastItem } from './lib/ToastItem';
export { useToast };
function createToastHubInstance(initConfig) {
    const toastHub = new ToastHub();
    if (initConfig) {
        toastHub.config(initConfig);
    }
    return {
        info: toastHub.info.bind(toastHub),
        success: toastHub.success.bind(toastHub),
        error: toastHub.error.bind(toastHub),
        warn: toastHub.warn.bind(toastHub),
        warning: toastHub.warning.bind(toastHub),
        destroy: toastHub.destroy.bind(toastHub),
        close: toastHub.close.bind(toastHub),
        config: toastHub.config.bind(toastHub),
    };
}
const defaultToastHub = createToastHubInstance();
const Toast = {
    create: createToastHubInstance,
    useToast,
    ...defaultToastHub,
};
export default Toast;
